// Configuração global de tradução e padrões
const tabulatorDefaultConfig = {
    maxHeight: "100%",
    height: "calc(100vh - 300px)",
    nestedFieldSeparator: ".",
    rowHeight: 35,
    columnDefaults: {
        // Isso garante que se você esqueceu o minWidth, 
        // o Tabulator não esmague a coluna menos de 80px
        minWidth: 100,
    },
    // Função que roda ao carregar a tabela
    tableBuilt: function () {
        this.getColumns().forEach(column => {
            var def = column.getDefinition();
            if (def.widthGrow && !def.minWidth) {
                column.updateDefinition({ minWidth: def.widthGrow * 100 });
            }
        });
    },
    renderComplete: function () {
        const tableHolder = this.getElement();
        const dropdowns = tableHolder.querySelectorAll('.card-drop:not(.initialized)');
        dropdowns.forEach(dropdownToggleEl => {
            new bootstrap.Dropdown(dropdownToggleEl, {
                popperConfig(defaultBsPopperConfig) {
                    return {
                        ...defaultBsPopperConfig,
                        strategy: 'fixed',
                        // FORÇA abrir para cima alinhado à direita dos pontos
                        placement: 'top-end',
                        modifiers: [
                            {
                                name: 'flip',
                                options: {
                                    // Se não couber em cima, ele tenta em baixo como última opção
                                    fallbackPlacements: ['bottom-end'],
                                },
                            },
                        ],
                    };
                },
            });
            dropdownToggleEl.classList.add('initialized');
        });
    },
    layout: "fitColumns",
    placeholder: "Nenhum registro foi encontrado...",
    selectableRows: false,
    responsiveLayout: false,
    pagination: "local",
    paginationSize: 15,
    paginationSizeSelector: [15, 30, 60, 90],
    paginationCounter: "rows",
    locale: "pt-br",
    langs: {
        "pt-br": {
            "pagination": {
                "page_size": "Linhas",
                "first": "Primeiro",
                "last": "Último",
                "prev": "Anterior",
                "next": "Próximo",
                "counter": {
                    "showing": "Exibindo",
                    "of": "de",
                    "rows": "linhas",
                }
            },
        }
    }
};

// Função global para ser usada em qualquer página
window.tabulatorRowClickEdit = function (tableInstance) {
    tableInstance.on("rowClick", function (e, row) {
        // 1. Ignora se clicar na coluna de ações (dropdown ou botões)
        if (e.target.closest(".cell-dropdown") || e.target.closest(".dropdown-menu")) {
            return;
        }

        // 2. Busca o link de editar dentro da linha usando a classe que você criou
        var linkEditar = row.getElement().querySelector(".btn-editar-tabulator");

        if (linkEditar) {
            var url = linkEditar.getAttribute("href");
            if (url && url !== "javascript:void(0);") {
                window.location.href = url;
            }
        }
    });
}

// Função para calcular minWidth proporcional aos pesos (widthGrow)
window.ajustaColunasTabulator = function (columns, multiplicador = 100) {
    return columns.map(col => {
        // Se a coluna tem peso (widthGrow) e NÃO tem um minWidth definido manualmente
        if (col.widthGrow && !col.minWidth) {
            col.minWidth = col.widthGrow * multiplicador;
        }
        return col;
    });
};